import React from 'react';
import Avatar, { AvatarProps } from '@material-ui/core/Avatar';
import { makeStyles } from '@material-ui/core';
import cx from 'classnames';

import { useImgix } from 'ha/modules/Image/useImgix';
import { constants } from 'ha/constants/commonConstants';
import { units } from '@ha/dsl';
import AnonSVG from 'img-src/static/anon.svg';

const createSizes = (size: number) => ({
  width: units.rem(size),
  height: units.rem(size),
});

const sizes = {
  lg: createSizes(10),
  md: createSizes(7),
  sm: createSizes(5),
  xsm: createSizes(4.3),
  xs: createSizes(3),
  xxs: createSizes(2),
  xxxs: createSizes(1.5),
};

const useStyles = makeStyles(() => ({
  ...sizes,
  filled: {
    backgroundColor: '#fff',
    backgroundPosition: '50%',
    backgroundSize: 'cover',
    borderRadius: '50%',
  },
}));

export type Size = keyof typeof sizes;

interface OwnProps {
  src?: string;
  size?: Size;
  filled?: boolean;
}

type Props = AvatarProps & OwnProps;

export const UserAvatar: React.FC<Props> = ({ src, size, filled, ...rest }) => {
  const classes = useStyles();
  const { transformImageURL } = useImgix();

  const getAvatarURL = React.useCallback(() => {
    if (!src || (src && src.includes(constants.defaultAvatarUrl))) {
      return AnonSVG;
    }
    return transformImageURL(src, { h: 120, w: 120 });
  }, [src, transformImageURL]);

  return (
    <Avatar
      data-test-locator="UserAvatar"
      className={cx(size ? classes[size] : '', { [classes.filled]: filled })}
      src={getAvatarURL()}
      {...rest}
    />
  );
};
